<nb-accordion class="mb-4">
  <nb-accordion-item [expanded]="true">
    <nb-accordion-item-header>
      <div class="d-flex align-items-center">
        <i class="far fa-chart-line ms-2"></i>
        <span>گزارش‌گیری</span>
      </div>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div class="row mb-3">
        <div class="col-12 col-lg-6">
          <nb-card>
            <nb-card-header>فقط کاربران لیست</nb-card-header>
            <nb-card-body>
              <app-user-picker
                (add)="includedUsers = $event"
                (remove)="includedUsers = $event"
                [cacheKey]="'transaction_included_users'"
              ></app-user-picker>
            </nb-card-body>
          </nb-card>
        </div>
        <div class="col-12 col-lg-6">
          <div class="d-flex align-items-center gap-3 mb-2">
            ارز
            <nb-toggle (checkedChange)="$event ? currencySelector.selectAll() : currencySelector.deselectAll()">انتخاب
              همه
            </nb-toggle>
          </div>
          <app-select-currency
            [multiple]="true"
            #currencySelector
            (currency)="selectedCurrency = $event"
          ></app-select-currency>
          <app-validation-error [errors]="validationErrors$ | async" name="currency"></app-validation-error>
          <div class="mt-4">
            <div class="datepicker-cont">
              <div>
                <label class="mb-2">تاریخ شروع</label>
                <app-datepicker (dateSelected)="setStartDate($event)"
                                #startDateEl></app-datepicker>
              </div>
              <div>
                <label class="mb-2">تاریخ پایان</label>
                <app-datepicker (dateSelected)="setEndDate($event)"
                                #endDateEl></app-datepicker>
              </div>
            </div>

            <app-validation-error [errors]="validationErrors$ | async" name="startTime"></app-validation-error>
            <app-validation-error [errors]="validationErrors$ | async" name="endTime"></app-validation-error>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-4">

        <button
          nbButton
          status="primary"
          (click)="clearFilters()"
        >حذف فیلتر
        </button>

        <button
          nbButton
          status="primary"
          (click)="report()"
          [nbSpinner]="loading"
          [disabled]="loading"
        >
          گزارش‌گیری
        </button>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
<app-gift-card
  [CreatedGiftCardUserId]="createdGiftCardUserIds"
  [currencyIds]="selectedCurrency"
  #giftCardComponent
></app-gift-card>
<nb-card>
  <nb-card-header>لیست برداشت‌های رمزارز</nb-card-header>
  <nb-card-body>
    <div class="d-none d-lg-flex align-items-center mb-2">
      <nb-select
        class="ms-2"
        [selected]="15"
        (selectedChange)="changeRecordPerPageLimit($event)"
        placeholder="تعداد رکورد"
      >
        <nb-option [value]="10">10</nb-option>
        <nb-option [value]="15">15</nb-option>
        <nb-option [value]="25">25</nb-option>
        <nb-option [value]="50">50</nb-option>
        <nb-option [value]="100">100</nb-option>
      </nb-select>
    </div>
    <p-table
      [value]="pagination.data"
      [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
      [lazy]="true"
      (onLazyLoad)="getCryptoWithdrawList($event)"
      [alwaysShowPaginator]="false"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="limit"
      [totalRecords]="pagination.totalRecords"
      [loading]="loading"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>شناسه کاربر</th>
          <th>شناسه</th>
          <th>ارز</th>
          <th>کاربر</th>
          <th>کیف پول</th>
          <th>شبکه</th>
          <th>تگ / ممو</th>
          <th>مقدار</th>
          <th>کارمزد</th>
          <th>وضعیت</th>
          <th>پیام</th>
          <th>مقصد</th>
          <th>تاریخ ایجاد</th>
          <th>آخرین ویرایش</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-withdraw>
        <tr>
          <td>{{ withdraw.user?.id }}</td>
          <td>{{ withdraw.id }}</td>
          <td>{{ withdraw.currency?.name }}</td>
          <td>
            <a
              class="text-primary"
              [routerLink]="withdraw.user?.id ? '/dashboard/user/' + withdraw.user?.id : null"
            >
              {{
              withdraw.user?.firstName || withdraw.user?.lastName
                ? withdraw.user.firstName + ' ' + withdraw.user.lastName
                : '-'
              }}
            </a>
          </td>
          <td class="code">
            <i
              (click)="copy(withdraw.wallet, 'آدرس کیف پول کپی شد.')"
              class="far fa-copy ms-2 align-middle cursor-pointer text-primary"
            ></i>
            <div class="d-inline-block" [nbTooltip]="withdraw.wallet" [nbTooltipClass]="'code'">
              <span>{{ withdraw.wallet.substring(0, 6)?.trim() }}</span>
              <i class="far fa-ellipsis-h mx-1 align-middle" style="opacity: 80%"></i>
              <span>
                {{
                withdraw.wallet
                  .substring(withdraw.wallet.length - 6, withdraw.wallet.length)
                  ?.trim()
                }}
              </span>
            </div>
          </td>
          <td>{{ withdraw.network ?? '-' }}</td>
          <td *ngIf="withdraw.tag; else emptyTd" class="code">
            <i
              (click)="copy(withdraw.wallet, 'آدرس کیف پول کپی شد.')"
              class="far fa-copy ms-2 cursor-pointer text-primary"
            ></i>
            {{ withdraw.tag }}
          </td>
          <td>
            {{ withdraw.amount | number : '1.0-8' }}
          </td>
          <td>
            {{ withdraw.fee | number : '1.0-8' }}
          </td>
          <td>
            <span
              [ngClass]="{
                'text-danger': withdraw.status === 'CANCELED',
                'text-success': withdraw.status === 'DONE',
                'text-warning': withdraw.status === 'PROCESSING' || withdraw.status === 'PENDING'
              }"
            >
              {{ withdraw.statusText }}
            </span>
          </td>
          <td *ngIf="withdraw.message; else emptyTd">
            <button
              (click)="copy(withdraw.message, 'متن پیام کپی شد.')"
              nbButton
              ghost
              [nbTooltip]="withdraw.message"
            >
              <i class="far fa-eye"></i>
            </button>
          </td>

          <td>
            <a
              *ngIf="withdraw.transferType === TransferType.Internal"
              href="/dashboard/user/{{withdraw.destinationUser.id}}"
              [nbPopover]="originTemp"
              nbPopoverPlacement="top"
              nbPopoverTrigger="hover"
              nbButton
              ghost
            >
              {{ withdraw.destinationUser.firstName + ' ' + withdraw.destinationUser.lastName}}
            </a>
            <ng-template #originTemp>
              <div class="origin-tooltip">
                <p>ایمیل: {{withdraw.destinationUser.email}}</p>
                <p>کیف پول: {{withdraw.destinationWallet}}</p>
              </div>

            </ng-template>

            <ng-container
              *ngIf="withdraw.transferType === TransferType.External">{{withdraw.transferType | transferType}}</ng-container>
          </td>

          <td>
            {{ withdraw.createdAt | dateFormat : 'HH:mm jYYYY/jMM/jDD' }}
          </td>
          <td>
            {{ withdraw.updatedAt | dateFormat : 'HH:mm jYYYY/jMM/jDD' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </nb-card-body>
</nb-card>

<ng-template #emptyTd>
  <td>-</td>
</ng-template>
